(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('AsignarDialogController', AsignarDialogController);

    AsignarDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'sSProyecto', 'sSPerfil', 'sSPeriodo', 'SSAsignacion', 'AlumnoUadyMatriculado', 'AlertService'];

    function AsignarDialogController ($scope, $stateParams, $uibModalInstance, entity, sSProyecto, sSPerfil, sSPeriodo, SSAsignacion, AlumnoUadyMatriculado, AlertService) {
        var vm = this;

        sSProyecto.$promise.then(function(result) {
        	vm.sSAsignacionDTO = entity;
        	vm.sSAsignacionDTO.unidadReceptora = result.unidadesReceptoras[0];
        	vm.sSAsignacionDTO.asignacion.duracionHoras = 480;
        	
			vm.iniPrestacionOptions = {
			    minDate: getToday(),
			    initDate: getToday()
			  };

			vm.finPrestacionOptions = {
			    minDate: getEnd(),
			    initDate: getEnd()
			  };
        });
        
        sSPerfil.$promise.then(function(result) {
        	vm.sSAsignacionDTO.perfil = result;
        }); 

        sSPeriodo.$promise.then(function(result) {
        	vm.sSAsignacionDTO.periodo = result;
        }); 
        
        
        vm.searchValue = '';
        vm.alumnoUadyMatriculados = null;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;        
        vm.clear = clear;
        vm.save = save;
        vm.searchStudent = searchStudent;
        vm.validateDates = validateDates;
        
        function getToday () {
        	var today = new Date();
        	today.setHours(0, 0, 0, 0);
        	return today;
        }
        
        function getEnd () {
        	var end = getToday();
        	end.setMonth(end.getMonth() + 6);
        	return end;
        }
        
        function getEndFromIni () {
        	if(vm.iniPrestacion == '')
        		console.log("EMPTY");
        	else
        		console.log("value : " + vm.iniPrestacion );
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function searchStudent () {
        	vm.sSAsignacionDTO.asignacion.prestador = null;
        	AlumnoUadyMatriculado.getActiveByCGSE({cgse : vm.sSAsignacionDTO.perfil.programaEducativo.claveCGSE, search : vm.searchValue}).$promise.then(function(result){
        		vm.alumnoUadyMatriculados = result;
        	});
        }
        function save () {
        	SSAsignacion.asignar(vm.sSAsignacionDTO, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSAsignacionCreate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }
        	
        function onSaveError () {
            vm.isSaving = false;
        }
        
        vm.datePickerOpenStatus.iniPrestacion = false;
        vm.datePickerOpenStatus.finPrestacion = false;
        
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
        function validateDates(){
        	var startDate = vm.sSAsignacionDTO.asignacion.iniPrestacion;
        	var endDate = vm.sSAsignacionDTO.asignacion.finPrestacion;
        	var minEndDate = angular.copy(startDate);
        	if(startDate != null && endDate != null){
	        	minEndDate.setMonth(startDate.getMonth() + 6);
	        	$scope.editForm.finPrestacion.$setValidity("endBeforeStart", endDate > startDate);
	        	$scope.editForm.finPrestacion.$setValidity("end6months", endDate >= minEndDate);
        	}
        }

    }
})();
